import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedSearchPage from '../../components/common/UnifiedSearchPage';
import { fetchSummaryInvoices } from '../../services/dataService';
import usePageTitle from '../../utils/usePageTitle';

const SummaryInvoice = () => {
  usePageTitle('Summary Invoice');
  const navigate = useNavigate();

  const getRowLink = (row) => `/summary-invoice/${row.projectCode}`;

  const handleRowClick = (row) => {
    navigate(getRowLink(row));
  };

  const columns = [
    { key: 'projectCode', label: 'Project Code' },
    { key: 'budgetCode', label: 'Budget Code' },
    { key: 'requestorName', label: 'Requestor Name' },
    { key: 'personInCharge', label: 'Person In Charge' },
    { key: 'modelName', label: 'Model Name' },
    { key: 'projectStatus', label: 'Project Status' }
  ];

  return (
    <UnifiedSearchPage
      title="Summary Invoice"
      columns={columns}
      onRowClick={handleRowClick}
      getRowLink={getRowLink}
      loadDataFunction={fetchSummaryInvoices}
    />
  );
};

export default SummaryInvoice;
